export const isStartingNewChat = (state: any) => state.startingNewChat;
export const hasStartNewChatError = (state: any) => state.startNewChatFailure;
export const patientChats = (state: any) => state.chats;
export const getAllChatsFailure = (state: any) => state.getAllChatsFailure;
export const getAllChatsSuccess = (state: any) => state.getAllChatsSuccess;
